
import config from '../views/home/config/home_api.js';
import PathUri from '@/utils/path_uri';
import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const service = {
    getHome: (idGroup, idEmpresa, idUsuario) => {
    return axios({
      method: 'get',
      url: `${config.baseUrl + _pathUri.generateUri() + idGroup}/empresas/bienvenida`,
      headers: {
        'idEmpresa': idEmpresa,
        'idUsuario': idUsuario
      },
    })
  },
}